import { Colors, InfoDot } from '@factorialco/deprecated-design-system'
import { PerformanceInsightsQuantityEnum } from 'generated/resources/graphql'

export const InsightsInfoDot: React.FC<{ value: `${PerformanceInsightsQuantityEnum}` }> = ({
  value,
}) => {
  const colors: Record<PerformanceInsightsQuantityEnum, Colors> = {
    low: 'radicalRed1000',
    normal: 'viridian400',
    high: 'viridian1000',
  }

  return <InfoDot size="medium" color={colors[value]} />
}
